import { useCallback, useMemo } from "react"
import { Button, ChevronRight, useStyletron } from "@mezo-org/mezo-clay"

import { SwappableToken } from "#/shared/types"
import { getCurrencySymbol } from "#/shared/utils"
import { TokenIcon } from "#/ui/Token"

type SwapModalTokenSelectorProps = {
  token: SwappableToken
  onClick: () => void
}

export default function SwapModalTokenSelector({
  token,
  onClick,
}: SwapModalTokenSelectorProps) {
  const [, theme] = useStyletron()

  const isMusdField = useMemo(() => token === "MUSD", [token])

  const assetSelectorHandler = useCallback(() => {
    if (isMusdField) return

    onClick()
  }, [onClick, isMusdField])

  return (
    <Button
      size="large"
      kind="secondary"
      type="button"
      $as={isMusdField ? "div" : "button"}
      onClick={assetSelectorHandler}
      startEnhancer={() => <TokenIcon token={token} />}
      endEnhancer={() =>
        isMusdField ? null : <ChevronRight color={theme.colors.black} />
      }
      overrides={{
        BaseButton: {
          style: () => ({
            width: "100%",
            maxWidth: "160px",
            ...(isMusdField
              ? {
                  cursor: "default",
                  ":hover": {
                    background: theme.colors.backgroundTertiary,
                    boxShadow: "none",
                  },
                  ":active": {
                    background: theme.colors.backgroundTertiary,
                    color: theme.colors.black,
                  },
                }
              : {}),
          }),
        },
      }}
    >
      {getCurrencySymbol(token)}
    </Button>
  )
}
